module.exports = __webpack_public_path__ + "media/4x3/hu-0d7409f8.svg";